<template>
   <div>
      <div v-if="concept">
         <b-table-simple class="table--stacked table--stacked--primary">
            <b-tbody>
               <b-tr>
                  <b-th class="w-101">Nama</b-th>
                  <b-td>{{concept.name}}</b-td>
               </b-tr>
               <b-tr>
                  <b-th>Definisi</b-th>
                  <b-td>{{concept.definition}}</b-td>
               </b-tr>
               <b-tr>
                  <b-th>Referensi</b-th>
                  <b-td>
                     <div v-for="(item,index) in concept.references" :key="index">
                        <span v-if="concept.references.length>1">{{index+1}}. </span>{{item}}
                     </div>
                  </b-td>
               </b-tr>
            </b-tbody>
         </b-table-simple>
         </div>
         <div v-if="variable">
            <b-table-simple class="table--stacked table--stacked--primary">
               <b-tbody>
                  <b-tr>
                  <b-th class="w-101">Nama</b-th>
                  <b-td>{{variable.name}}</b-td>
                  </b-tr>
                  <b-tr>
                  <b-th>Definisi</b-th>
                  <b-td>{{variable.definition}}</b-td>
                  </b-tr>
                  <b-tr>
                  <b-th>Konsep</b-th>
                  <b-td style="padding:0px !important">
                     <b-table-simple class="table--borderless table--light">
                        <b-thead>
                        <tr>
                           <th style="background:none" class="w-51">No</th>
                           <th class="text-left" style="background:none">Nama</th>
                           <th class="text-left" style="background:none">Definisi</th>
                           <th style="background:none">Status</th>
                        </tr>
                        </b-thead>
                        <b-tbody>
                        <b-tr v-for="(concept,index) in variable.concepts" :key="index">
                           <b-td class="text-center">{{index+1}}</b-td>
                           <b-td>{{concept.name}}</b-td>
                           <b-td>{{concept.definition}}</b-td>
                           <b-td class="text-center text-nowrap">
                              <span :class="'status status--'+statusFormatterStyle(concept.status)">{{statusFormatter(concept.status)}}</span>
                           </b-td>
                        </b-tr>
                        </b-tbody>
                     </b-table-simple>
                  </b-td>
                  </b-tr>
                  <b-tr>
                  <b-th>Unit Observasi</b-th>
                  <b-td>
                     <div v-for="(item,index) in variable.unit_types" :key="index" class="d-flex">
                        <div v-if="variable.unit_types.length>1" class="w-20">{{index+1}}.</div>
                        <div>{{item.name}}</div>
                     </div>
                  </b-td>
                  </b-tr>
                  <b-tr>
                  <b-th>Ukuran</b-th>
                  <b-td>{{variable.measurement ? variable.measurement.name: '-'}}</b-td>
                  </b-tr>
                  <b-tr>
                  <b-th>Satuan</b-th>
                  <b-td>{{variable.measurement_unit ? variable.measurement_unit.name: '-'}}</b-td>
                  </b-tr>
                  <b-tr>
                  <b-th>Subjek</b-th>
                  <b-td>{{variable.subject_field ? variable.subject_field.name: '-'}}</b-td>
                  </b-tr>
                  <b-tr>
                  <b-th>Value Domain</b-th>
                  <b-td style="padding:0px !important">
                     <div class="d-flex" style="padding:7px 10px 5px 10px;">
                        <div class="w-120 text-semi-bold text-12" style="color:teal">Jenis value domain</div>
                        <div class="text-center w-20">:</div>
                        <div>{{variable.value_domain.type.id == 76 ? 'Kategori':'Non Kategori'}}</div>
                     </div>
                     <div class="d-flex" style="padding:0px 10px 10px 10px; border-bottom:1px solid #BDBDBD" v-if="variable.value_domain.type.id == 76 ">
                        <div class="w-120 text-semi-bold text-12" style="color:teal">Referensi klasifikasi</div>
                        <div class="text-center w-20">:</div>
                        <div>{{variable.value_domain.classification_reference? variable.value_domain.classification_reference:'Tidak menggunakan'}}</div>
                     </div>
                     <b-table-simple class="table--borderless table--light" v-if="variable.value_domain.type.id == 76 ">
                        <b-thead>
                        <tr>
                           <th class="text-center w-60" style="background:none">Kode</th>
                           <th class="text-left w-30p" style="background:none">Nama</th>
                           <th class="text-left" style="background:none">Deskripsi</th>
                        </tr>
                        </b-thead>
                        <b-tbody>
                        <b-tr v-for="(item,index) in variable.value_domain.items" :key="index">
                           <b-td class="text-center" >{{item.code}}</b-td>
                           <b-td>{{item.name}}</b-td>
                           <b-td>{{item.description ? item.description  :'-'}}</b-td>
                        </b-tr>
                        </b-tbody>
                     </b-table-simple>
                  </b-td>
                  </b-tr>
                  <b-tr>
                  <b-th>Referensi</b-th>
                  <b-td>
                     <div v-for="(item,index) in variable.references" :key="index" class="d-flex">
                        <div v-if="variable.references.length>1" class="w-20">{{index+1}}.</div>
                        <div>{{item}}</div>
                     </div>
                  </b-td>
                  </b-tr>
               </b-tbody>
            </b-table-simple>
         </div>
         <div v-if="indicator">
            <b-table-simple class="table--stacked table--stacked--primary">
               <b-tbody>
                  <b-tr>
                  <b-th class="w-101">Nama</b-th>
                  <b-td>{{indicator.name}}</b-td>
                  </b-tr>
                  <b-tr>
                  <b-th>Definisi</b-th>
                  <b-td>{{indicator.definition}}</b-td>
                  </b-tr>
                  <b-tr>
                  <b-th>Konsep</b-th>
                  <b-td style="padding:0px !important">
                     <b-table-simple class="table--borderless table--light">
                        <b-thead>
                        <tr>
                           <th style="background:none" class="w-51">No</th>
                           <th class="text-left" style="background:none">Nama</th>
                           <th class="text-left" style="background:none">Definisi</th>
                           <th style="background:none">Status</th>
                        </tr>
                        </b-thead>
                        <b-tbody>
                        <b-tr v-for="(concept,index) in indicator.concepts" :key="index">
                           <b-td class="text-center">{{index+1}}</b-td>
                           <b-td>{{concept.name}}</b-td>
                           <b-td>{{concept.definition}}</b-td>
                           <b-td class="text-center">
                              <span :class="'status status--'+statusFormatterStyle(concept.status)">{{statusFormatter(concept.status)}}</span>
                           </b-td>
                        </b-tr>
                        </b-tbody>
                     </b-table-simple>
                  </b-td>
                  </b-tr>
                  <b-tr>
                  <b-th>Ukuran</b-th>
                  <b-td>{{indicator.measurement ? indicator.measurement.name: '-'}}</b-td>
                  </b-tr>
                  <b-tr>
                  <b-th>Satuan</b-th>
                  <b-td>{{indicator.measurement_unit ? indicator.measurement_unit.name: '-'}}</b-td>
                  </b-tr>
                  <b-tr>
                  <b-th>Subjek</b-th>
                  <b-td>{{indicator.subject_field ? indicator.subject_field.name: '-'}}</b-td>
                  </b-tr>
                  <b-tr>
                  <b-th>Manfaat</b-th>
                  <b-td>{{indicator.benefit ? indicator.benefit: '-'}}</b-td>
                  </b-tr>
                  <b-tr>
                  <b-th>Interpretasi</b-th>
                  <b-td>{{indicator.interpretation ? indicator.interpretation: '-'}}</b-td>
                  </b-tr>
                  <b-tr>
                  <b-th>Level terkecil tersedianya data</b-th>
                  <b-td>
                     <div v-for="(item,index) in indicator.presentation_levels" :key="index" class="d-flex">
                        <div v-if="indicator.presentation_levels.length>1" class="w-20">{{index+1}}.</div>
                        <div>{{item.name}}</div>
                     </div>
                  </b-td>
                  </b-tr>
                  <b-tr>
                  <b-th>Mekanisme Perhitungan</b-th>
                  <b-td>{{indicator.calculation_mechanism ? indicator.calculation_mechanism : '-'}}</b-td>
                  </b-tr>
                  <b-tr>
                  <b-th>Rumus</b-th>
                  <b-td>
                     <EquationViewer :value="indicator.formula ? indicator.formula : '-'"></EquationViewer>
                     <div class="mt-2 equation-structure" v-if="indicator.formula">
                        <div class="i-text-field-name" style="color:teal">Keterangan:</div>
                        <b-table-simple class="table table--form">
                        <b-tbody>
                           <b-tr v-for="(item,index) in indicator.formula_structures" :key="index">
                              <b-td :style="item.symbol && item.symbol.length<6 ? 'width:1px;white-space:nowrap ':''" style="border:none !important;padding:0px 1px !important">
                              <EquationViewer :value="item.symbol? item.symbol : '-'"></EquationViewer>
                              </b-td>
                              <b-td style="vertical-align:middle;border:none !important;padding:0px 5px !important">
                              : &nbsp; {{item.description}}
                              </b-td>
                           </b-tr>
                        </b-tbody>
                        </b-table-simple>
                     </div>
                  </b-td>
                  </b-tr>
                  <b-tr>
                  <b-th>Disaggregasi</b-th>
                  <b-td style="padding:0px !important">
                     <b-table-simple class="table--borderless table--light">
                        <b-thead>
                        <tr>
                           <th style="background:none" class="w-51">No</th>
                           <th class="text-left" style="background:none">Nama</th>
                           <th class="text-left" style="background:none">Definisi</th>
                           <th style="background:none">Status</th>
                        </tr>
                        </b-thead>
                        <b-tbody>
                        <b-tr v-for="(disaggregation,index) in indicator.disaggregations" :key="index">
                           <b-td class="text-center">{{index+1}}</b-td>
                           <b-td>{{disaggregation.name}}</b-td>
                           <b-td>{{disaggregation.definition}}</b-td>
                           <b-td class="text-center">
                              <span :class="'status status--'+statusFormatterStyle(disaggregation.status)">{{statusFormatter(disaggregation.status)}}</span>
                           </b-td>
                        </b-tr>
                        </b-tbody>
                     </b-table-simple>
                  </b-td>
                  </b-tr>
                  <b-tr>
                  <b-th>Referensi</b-th>
                  <b-td>
                     <div v-for="(item,index) in indicator.references" :key="index" class="d-flex">
                        <div v-if="indicator.references.length>1" class="w-20">{{index+1}}.</div>
                        <div>{{item}}</div>
                     </div>
                  </b-td>
                  </b-tr>
               </b-tbody>
            </b-table-simple>
         
         </div>
   </div>
</template>
<script>
import "@/assets/scss/main.scss";
import EquationViewer from "@/components/equation/EquationViewer";
import sdsService from "../services/SdsService";
import SubjectField from '../views/sds/data/subject_field.js';
export default {
   components:{
      EquationViewer
   },
   props: ['id'],
   mounted(){
      if(this.id !=null){
            this.getSdsItem();
         }
   },
   data(){
      return {
         sdsItem:null,
         concept:null,
         variable:null,
         indicator:null,
         form:null,
         options:{
            unit_type:[],
            measurement:[],
            measurement_unit:[],
            value_domain_type:[
               { value: { id: 75, name: 'Described Value Domain', description:'Jenis value domain yang nilai dinyatakan dalam bentuk ekspresi atau deskripsi' }, text: 'Non Kategori',},
               { value: { id: 76, name: 'Enumerated Value Domain', description: 'Jenis value domain yang nilai dinyatakan sebagai daftar kode dan kategori' }, text: 'Kategori' },
            ],
            status:[
               {value:'DRAFT_KABKOTA', label:'Draft Produsen Data Kabupaten/Kota'},
               {value:'SUBMITTED_KABKOTA', label:'Submit Produsen Data Kabupaten/Kota'},
               {value:'REVIEW_KABKOTA', label:'Diperiksa Walidata Kabupaten/Kota'},
               {value:'CORRECTION_KABKOTA', label:'Perbaikan Produsen Data & Walidata Kabupaten/Kota'},
               {value:'PENDING_KABKOTA', label:'Ditunda Walidata Kabupaten/Kota'},
               {value:'REJECTED_KABKOTA', label:'Ditolak Walidata Kabupaten/Kota'},
               {value:'APPROVED_KABKOTA', label:'Diterima Walidata Kabupaten/Kota'},

               {value:'DRAFT_PROVINSI', label:'Draft Produsen Data Provinsi'},
               {value:'SUBMITTED_PROVINSI', label:'Submit Produsen Data Provinsi'},
               {value:'REVIEW_PROVINSI', label:'Diperiksa Walidata Provinsi'},
               {value:'CORRECTION_PROVINSI', label:'Perbaikan Produsen Data & Walidata Provinsi'},
               {value:'REJECTED_PROVINSI', label:'Ditolak Walidata Provinsi'},
               {value:'APPROVED_PROVINSI', label:'Diterima Walidata Provinsi'},
               {value:'PENDING_PROVINSI', label:'Ditunda Walidata Provinsi'},

               {value:'DRAFT_PUSAT', label:'Draft Produsen Data Pusat'},
               {value:'SUBMITTED_PUSAT', label:'Submit Produsen Data Pusat'},
               {value:'REVIEW_PUSAT', label:'Diperiksa Walidata Pusat'},
               {value:'CORRECTION_PUSAT', label:'Perbaikan Produsen Data & Walidata Pusat'},
               {value:'REJECTED_PUSAT', label:'Ditolak Walidata Pusat'},
               {value:'APPROVED_PUSAT', label:'Diterima Walidata Pusat'},
               {value:'PENDING_PUSAT', label:'Ditunda Walidata Pusat'},
               {value:'PUBLISHED_PUSAT', label:'Publish'},
            ],
         }
      }
   },
   watch:{
      id(){
         if(this.id !=null){
            this.getSdsItem();
         }
      },
   },
   methods:{
      statusFormatter(status){
         return status && this.options.status.find(x=>x.value == status) !=null ? this.options.status.find(x=>x.value == status).label : 'Draft';
      },
      statusFormatterStyle(status){
         return status ? status.split('_')[0].toLowerCase() : 'draft';
      },
      async getSdsItem(){
         await sdsService.getSdsItem(this.id).then(
            async (result)=>{
               this.sdsItem = {...result.data.result[0]};
               let x = this.sdsItem;
               this.form={
                  data: x.data,
                  submission_period: x.submission_period,
                  submission_type: x.submission_type,
                  sds_type: x.sds_type,
                  status: x.status,
                  rejection_note: x.rejection_note,
                  alternative_sds_item_id: x.alternative_sds_item_id,
                  rejected_similiar_item_ids:[],
                  submitter: this.user,
                  produsen_data: {
                  id: x.produsen_data_id,
                  name: x.produsen_data_name,
                  province_code: x.produsen_data_province_code,
                  city_code: x.produsen_data_city_code,
                  },
                  walidata_pusat: {
                  id: x.walidata_pusat_id,
                  name: x.walidata_pusat_name,
                  },
                  reviews:x.review ? x.review : [],
                  proposed_walidata_kabupaten_kota:	false,
                  proposed_walidata_provinsi:	false,
                  proposed_walidata_pusat:	false,
               };
               if(this.form.sds_type == 'CONCEPT'){
                  this.concept = this.form.submissionPeriod > 2022 ? this.form.data.concept : this.updateConceptStructure(this.form.data.concept, this.form.submission_type);
                  
               }
               else if(this.form.sds_type == 'VARIABLE'){
                  this.variable = this.form.submissionPeriod > 2022 ? this.form.data.variable : this.updateVariableStructure(this.form.data.variable, this.form.submission_type);
                  this.syncVariableReference();
               }
               else{
                  this.indicator = this.form.submissionPeriod > 2022 ? this.form.data.indicator : this.updateIndicatorStructure(this.form.data.indicator, this.form.submission_type);
                  this.syncIndicatorReference();
               }
            },
            (error)=>{
               console.log(error);
            }
         );
      },
      updateConceptStructure(concept,submissionType){
         let newConcept = {
         code: concept.code,
         name: concept.name,
         definition: concept.definition,
         references: concept.references.map(x=>typeof x == 'string' ? x : x.name),
         updated_concept: null,
         }
         if(submissionType == 'UPDATE'){
         newConcept.updated_concept = {
            changes_type : 'MODIFY', 
            items: []
         }
         if('updated_concept' in concept){
            newConcept.updated_concept = concept.updated_concept;
         }else{
            let newUpdatedConcept = concept.current_version;
            newUpdatedConcept.references = newUpdatedConcept.references.map(x=>x.name),
            
            newConcept.updated_concept = {
               changes_type : 'MODIFY', 
               items: [newUpdatedConcept]
            }
         }
         }
         return newConcept;
      },
      updateVariableStructure(variable,submissionType){
         let newVariable = {
         code: variable.code,
         name: variable.name,
         definition: variable.definition,
         concepts: ('concept' in variable) ? variable.concept : variable.concepts, //update with actual state,
         unit_types: variable.unit_types, //change format json
         measurement: variable.measurement, //change format json
         measurement_unit: variable.measurement_unit, //change format json,
         subject_field: variable.subject_field, //change format json,
         value_domain: variable.value_domain, //change format json
         rule: variable.rule,
         references: variable.references.map(x=>typeof x == 'string' ? x : x.name),
         updated_variable: null,
         }
         if(submissionType == 'UPDATE'){
         if('updated_variable' in variable){
            newVariable.updated_variable = variable.updated_variable;
         }else{
            let newUpdatedVariable = variable.current_version;
            newUpdatedVariable.references = newUpdatedVariable.references.map(x=>typeof x == 'string' ? x : x.name);
            let newValueDomain  = {
               type: null,// change use current format
               classification_reference: null,
               items:[],
               total_levels:0
            }
            if('classification' in newUpdatedVariable.value_domain){
               newValueDomain.items = newUpdatedVariable.value_domain.classification.items;
            }else{
               newValueDomain.items = newUpdatedVariable.value_domain.items;
            }
            newUpdatedVariable.value_domain = newValueDomain;

            newVariable.updated_variable = {
               changes_type : 'MODIFY', 
               items: [newUpdatedVariable]
            }
         }

         }
         //change format json for unit types 
         // if(newVariable.unit_types != null & newVariable.unit_types.length>0){
         //    newVariable.unit_types = newVariable.unit_types.filter(x=>x!=null).map(item => {
         //       if(item.id == null){
         //          let _newUnitTypes = {
         //             id:null,
         //             name:item.name,
         //             description:null,
         //          };
         //          return _newUnitTypes;
         //       }else{
         //          return this.options.unit_type.find(x => x.id == item.id);
         //       }        
         //    });
         // }
         //change format json for measurement 
         // if(newVariable.measurement){
         //    if(newVariable.measurement.id == null){
         //       let newMeasurement = {
         //          id:null,
         //          name:newVariable.measurement.name,
         //          description:null,
         //       };
         //       newVariable.measurement = newMeasurement;
         //    }else{
         //       newVariable.measurement = this.measurements.find(x => x.id == newVariable.measurement.id);
         //    }
         // }
         //change format json for measurement unit
         // if(newVariable.measurement_unit){
         //    if(newVariable.measurement_unit.id == null){
         //       let newMeasurementUnit = {
         //          id: null,
         //          name: newVariable.measurement_unit.name,
         //          symbol: null
         //       }
         //       newVariable.measurement_unit = newMeasurementUnit;
         //    }else{
         //       newVariable.measurement_unit = this.variableMeasurementUnits.find(x => x.id == newVariable.measurement_unit.id);
         //    }
         // }
         //change format json for subject_field
         if(newVariable.subject_field){
            let subjects =  [...SubjectField]
            newVariable.subject_field = subjects.map(({id,code,name,description})=>({id,code,name,description})).find(x => x.id == newVariable.subject_field.id);
         }
         //change format json for value domain
         // console.log(newVariable.value_domain)
         if(newVariable.value_domain){
            let newValueDomain  = {
               type: null,// change use current format
               classification_reference: null,
               items:[],
               total_levels:0
            }
            if(newVariable.value_domain.type && newVariable.value_domain.type.id != null){
               newValueDomain.type = this.options.value_domain_type.map(x=> x.value).find(x => x.id == newVariable.value_domain.type.id);
               if(newValueDomain.type.id == 76){
                  if('classification' in newVariable.value_domain){
                  newValueDomain.classification_reference = newVariable.value_domain.classification.id ? {
                     id: newVariable.value_domain.classification.id,
                     name: newVariable.value_domain.classification.name,
                     description: null,
                     used_type: newVariable.value_domain.classification.items.length>0 ? 'PARTIAL' : 'FULL',
                  } : null;
                  newValueDomain.items = newVariable.value_domain.classification.items;
                  }else{
                  newValueDomain.classification_reference = newVariable.value_domain.classification_reference;
                  newValueDomain.items = newVariable.value_domain.items;
                  }
               }
            }
            newVariable.value_domain = newValueDomain;
            }
         return newVariable;
      },
      //4.1 INDICATOR
      updateIndicatorStructure(indicator,submissionType){
         // let submissionType = sdsItem.submission_type;
         // let indicator = sdsItem.data.indicator;

         let newIndicator = {
         code: indicator.code,
         name: indicator.name,
         definition: indicator.definition,
         concepts: indicator.concepts, //update with actual state,
         measurement: indicator.measurement, //change format json
         measurement_unit: indicator.measurement_unit, //change format json,
         subject_field: indicator.subject_field, //change format json,
         benefit: indicator.benefit,
         interpretation: indicator.interpretation,
         presentation_levels: indicator.presentation_levels, //change format json,
         calculation_mechanism: indicator.calculation_mechanism,
         formula: indicator.formula,
         formula_structures: indicator.formula_structures,
         disaggregations: indicator.disaggregations, //update with actual state,
         references: indicator.references.map(x=>typeof x == 'string' ? x : x.name),
         updated_indicator: null,
         }
         if(submissionType == 'UPDATE'){
         if('updated_indicator' in indicator){
            newIndicator.updated_indicator = indicator.updated_indicator;
         }else{
            let newUpdatedIndicator = indicator.current_version;
            newUpdatedIndicator.references = newUpdatedIndicator.references.map(x=>typeof x == 'string' ? x : x.name);
            newIndicator.updated_indicator = {
               changes_type : 'MODIFY', 
               items: [newUpdatedIndicator]
            }
         }
         }
         //change format json for measurement 
         if(newIndicator.measurement){
         if(newIndicator.measurement.id == null){
            let newMeasurement = {
               id:null,
               name: newIndicator.measurement.name,
               description:null,
            };
            newIndicator.measurement = newMeasurement;
         }else{
            newIndicator.measurement = this.measurements.find(x => x.id == newIndicator.measurement.id);
         }
         }
         //change format json for measurement unit
         if(newIndicator.measurement_unit){
         if(newIndicator.measurement_unit.id == null){
            let newMeasurementUnit = {
               id: null,
               name: newIndicator.measurement_unit.name,
               symbol: null
            } 
            newIndicator.measurement_unit = newMeasurementUnit;
         }else{
            newIndicator.measurement_unit = this.indicatorMeasurementUnits.find(x => x.id == newIndicator.measurement_unit.id);
         }
         }
         //change format json for subject_field
         if(newIndicator.subject_field){
         let subjects =  [...SubjectField]
         newIndicator.subject_field = subjects.map(({id,code,name,description})=>({id,code,name,description})).find(x => x.id == newIndicator.subject_field.id);
         }
         //change format json for presentation levels
         if(newIndicator.presentation_levels != null & newIndicator.presentation_levels.length>0){
         //there is posibilty that there is a duplicate item, so we will remove it
         let unique = new Set();
         newIndicator.presentation_levels = newIndicator.presentation_levels.filter(obj => {
            let isPresent = unique.has(obj.id);
            unique.add(obj.id);
            return !isPresent;
         });
         
         newIndicator.presentation_levels = newIndicator.presentation_levels.map(item => {
            let z = this.options.presentation_level.map(x=> x.value).find(x => x.id == item.id);
            return z;
         });
         }
         //update variable as indicator disaggregations with actual state
         if(newIndicator.disaggregations != null & newIndicator.disaggregations.length>0){
         newIndicator.disaggregations = newIndicator.disaggregations.map(item => {
            if(item.submission_id){
               return this.options.variable.find(x => x.submission_id == item.submission_id);
            }else{
               return this.options.variable.find(x => x.content_id == item.id);
            }            
         });
         }
         return newIndicator;
      },
      async syncVariableReference(){
        
         let concepts = [...this.variable.concepts];
         this.variable.concepts = await Promise.all(concepts.map(async (item) => {
               let concept = null;
               if(this.sdsItem.submission_period==2022){
                  let id = item.submission_id;
                  await sdsService.getOldSdsItem(id).then(
                     (result)=>{
                        concept = {...result.data.result[0]};
                        concept.definition = concept.data.concept.definition;
                        concept.source = 'USULAN';
                        
                     },
                     (error)=>{
                        console.log(error);
                     }
                  );
               }else{
                  await sdsService.getSdsItem(item.id).then(
                     (result)=>{
                        concept = {...result.data.result[0]};
                        concept.definition = concept.data.concept.definition;
                        concept.source = 'USULAN';
                        
                     },
                     (error)=>{
                        console.log(error);
                     }
                  );
               }
               return concept;
         }));  
         
      
    },
    async syncIndicatorReference(){
      let concepts = [...this.indicator.concepts];
      this.indicator.concepts = await Promise.all(concepts.map(async (item) => {
            let concept = null;
            if(this.sdsItem.submission_period==2022){
            let id = item.submission_id;
               await sdsService.getOldSdsItem(id).then(
               (result)=>{
                  concept = {...result.data.result[0]};
                  concept.definition = concept.data.concept.definition;
                  concept.source = 'USULAN';
                  
               },
               (error)=>{
                  console.log(error);
               }
            );
            }else{
            await sdsService.getSdsItem(item.id).then(
               (result)=>{
                  concept = {...result.data.result[0]};
                  concept.definition = concept.data.concept.definition;
                  concept.source = 'USULAN';
                  
               },
               (error)=>{
                  console.log(error);
               }
            );
            }
            return concept;
      })); 

      let disaggregations = [...this.indicator.disaggregations];
      this.indicator.disaggregations = await Promise.all(disaggregations.map(async (item) => {
          let disaggregation = null;
            if(this.sdsItem.submission_period==2022){
              let id = item.submission_id;
               await sdsService.getOldSdsItem(id).then(
                (result)=>{
                  disaggregation = {...result.data.result[0]};
                  disaggregation.definition = disaggregation.data.variable.definition;
                  disaggregation.source = 'USULAN';
                  
                },
                (error)=>{
                  console.log(error);
                }
              );
            }else{
              await sdsService.getSdsItem(item.id).then(
                (result)=>{
                  disaggregation = {...result.data.result[0]};
                  disaggregation.definition = disaggregation.data.variable.definition;
                  disaggregation.source = 'USULAN';
                  
                },
                (error)=>{
                  console.log(error);
                }
              );
            }
            return disaggregation;
      })); 
      
    },

   }
}
</script>